var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { AvailablePopover } from '../../../../components/other/AvailablePopover';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarIconInfo_ = class MenubarIconInfo_ extends React.PureComponent {
    get color() {
        if (this.props.app.menubar.menubarRight.isInfoMenuOpen) {
            return '#fff';
        }
        return '#9d9d9d';
    }
    get background() {
        if (this.props.app.menubar.menubarRight.isInfoMenuOpen) {
            return 'linear-gradient(to bottom, #080808 0%, #0f0f0f 100%)';
        }
        return undefined;
    }
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(AvailablePopover, { content: React.createElement("span", { style: { fontWeight: 500, fontSize: 14 } }, "Informationen, Impressum, Datenschutz und Cookie-Einstellungen"), overlayStyle: { paddingTop: 0 }, placement: "bottom", visible: app.menubar.menubarRight.isInfoIconHovering && !app.menubar.menubarRight.isInfoMenuOpen },
                React.createElement("div", { style: {
                        color: this.color,
                        background: this.background,
                    }, className: "MenubarRightIconButton", onMouseUp: action((e) => {
                        app.menubar.menubarRight.isInfoMenuOpen = !app.menubar.menubarRight.isInfoMenuOpen;
                        app.menubar.menubarRight.isInfoIconHovering = false;
                    }), onMouseEnter: action(() => (app.menubar.menubarRight.isInfoIconHovering = true)), onMouseLeave: action(() => (app.menubar.menubarRight.isInfoIconHovering = false)) },
                    React.createElement("i", { className: "fas fa-info" }))),
            this.infoMenu));
    }
    get infoMenu() {
        const { app } = this.props;
        if (!app.menubar.menubarRight.isInfoMenuOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarIconInfoMenu } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarIconInfoMenu, { app: app });
    }
};
MenubarIconInfo_ = __decorate([
    observer
], MenubarIconInfo_);
export { MenubarIconInfo_ };
